const initialState = {
  data: "FirstData",
};

export default (state = { ...initialState }) => {
  return state;
};
